import React from "react";
import CloudMembershipHero from "../components/CloudMembershipHero";
import HowWeHelp from "../components/HowWeHelp";
import CloudStartUpPlan from "../components/CloudStartPlan";

const CloudMembershipPage = () => {
    return (
        <div>
            <CloudMembershipHero/>
            <CloudStartUpPlan/>
            <HowWeHelp />
        </div>
    );
};

export default CloudMembershipPage;
